import { useEffect, useRef, useState } from "react";
import Cpu from "../components/Cpu";
import Wifi from "../components/Wifi";
import Lan from "../components/Lan";
import Rst from "../components/Rst";
import Led from "../components/Led";
import Ct from "../components/Ct";
import Rs from "../components/Rs";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import PrinterData from "../components/PrinterData";

const stepsWithIcon = [
    { label: "CPU(メモリ/ストレージ)", icon: "cpu", component: <Cpu /> },
    { label: "LANポート", icon: "lan", component: <Lan /> },
    { label: "Wi-Fi(STA/AP)", icon: "wifi", component: <Wifi /> },
    { label: "周辺機器", icon: "box", component: <Led /> },
]
const stepsWithoutIcon = [
    { label: "LED", icon: null, component: <Led /> },
    { label: "RSTボタン", icon: null, component: <Rst /> },
    { label: "CT/SPI", icon: null, component: <Ct /> },
    { label: "RS-485", icon: null, component: <Rs /> },
]
const Check = () => {
    const [stage, setStage] = useState(null);
    const [finalStage, setFinalStage] = useState(false);
    const [lineHeight, setLineHeight] = useState(0);
    const lineRef = useRef(null); // Ref to access the line element
    const [showLoader, setShowLoader] = useState(true);
    const [showFinalLoader, setShowFinalLoader] = useState(false);
    const totalSteps = stepsWithIcon.length + stepsWithoutIcon.length;
    const navigate = useNavigate();
    const navigateTo = () => {
        navigate('/')
    }
    useEffect(() => {

        const modalTimer = setTimeout(() => {
            setShowLoader(false);
            setStage(0);
        }, 3000);

        return () => clearTimeout(modalTimer);
    }, []);
    useEffect(() => {

        if (!showLoader) {
            const interval = setInterval(() => {
                setStage((prev) => (prev < totalSteps ? prev + 1 : prev));

            }, 3000);

            return () => clearInterval(interval);
        }
        //eslint-disable-next-line

    }, [showLoader, totalSteps]);

    useEffect(() => {
        if (stage > 0 && stage !== totalSteps) {
            const calculateHeight = () => {
                if (window.innerWidth > 1400) {
                    return 53; // For large screens
                } else if (window.innerWidth > 1024) {
                    return 38; // For medium screens
                } else {
                    return 36; // For small screens
                }
            };

            if (stage > 0 && stage !== totalSteps) {
                setLineHeight(stage * calculateHeight()); // Calculate height dynamically
            }
        } else if (stage === totalSteps) {
            setShowFinalLoader(true);
            const finalModalTimer = setTimeout(() => {
                setShowFinalLoader(false);
                setFinalStage(true);
            }, 3000);

            return () => clearTimeout(finalModalTimer);
        }

    },
        //eslint-disable-next-line
        [stage]);

    return (

        <div className="row main-box">
            <div className=" col-12 col-md-5 col-lg-4 image-box image-box-after">
                <div className="content-box">
                    <div className={`${finalStage ? "header-box final-stage" : "header-box"}`}>
                        {/* <div className="header-box "> */}
                        <div className="logo-box">
                            <img src="img/logo.png" alt="logo" className="logo logo-animate" />
                        </div>
                        <div className="heading-box">レギュラーモデル</div>
                    </div>

                    <div className={`${finalStage ? "process-box final-stage" : "process-box"}`}>
                        {/* <div className="process-box"> */}
                        <div ref={lineRef} className="line" style={{
                            height: `${lineHeight}px`, // Apply dynamic height
                        }}></div>

                        {stepsWithIcon.map((step, index) => (
                            <div
                                key={index}
                                className={`step-with-icon ${index <= stage ? "active" : ""}`}
                            >
                                <div className={`icon-box ${index == stage ? "active-box" : ""}`}>
                                    {index == stage ? (<img src={`img/${step.icon}-blue.png`} alt={step.label} />) : (<img src={`img/${step.icon}.png`} alt={step.label} />)}
                                </div>

                                <div className={`headline-box ${index == stage ? "active-box" : ""}`}>{step.label}</div>

                                {!showLoader && <div className="tick-icon">
                                    {index < stage ? (<img src="img/checkmark.png" alt="checkmark" />) : (<div className="loader"></div>)}
                                </div>}

                            </div>
                        ))}

                        {stepsWithoutIcon.map((step, index) => {
                            const overallIndex = index + stepsWithIcon.length;
                            return (
                                <div
                                    key={index}
                                    className={`step-without-icon  ${overallIndex <= stage ? "active" : ""}`}
                                >
                                    <div className={`headline-box ${overallIndex == stage ? "active-box" : ""}`}>{step.label}</div>

                                    <div className="tick-icon">

                                        {/* {overallIndex === 4 ? (
                                            <img src="img/checkmark.png" alt="checkmark" />
                                        ) : overallIndex < stage ? (
                                            <img src="img/error.png" alt="error" />
                                        ) : (
                                            <div className="loader"></div>
                                        )} */}
                                        <img src="img/checkmark.png" alt="checkmark" />

                                    </div>

                                </div>
                            );
                        })}
                        {showFinalLoader && <div className="final-loader-box"><div className="loader"></div></div>}
                    </div>

                    {finalStage && <div className="final-blocks">
                        <div className="print-box">概要<img src="img/print-icon.png" /></div>
                        <div className="back-box" onClick={() => navigateTo()}>竣成</div>
                    </div>}
                </div>
                <div className="hardware-box">
                    <img
                        src="img/hardware_image.png"
                        alt="hardware_image"
                        className={`${finalStage ? "hardware-image final-stage" : "hardware-image"}`}
                    />
                    {/* <img
                            src="img/hardware_image.png"
                            alt="hardware_image"
                            className="hardware-image"
                        /> */}
                </div>
            </div>

            <div className="col-12 col-md-7 col-lg-8 monitor-wrapper">
                {finalStage ? (
                    <PrinterData />
                ) : (
                    <div className="monitor-box">
                        <div className="screen">
                            {showLoader && (<Loader />)}
                            {!showLoader && (
                                (stage < totalSteps)
                                    ? (stage < stepsWithIcon.length
                                        ? stepsWithIcon[stage]?.component
                                        : stepsWithoutIcon[stage - stepsWithIcon.length]?.component)
                                    : (stepsWithoutIcon.length > 0
                                        ? stepsWithoutIcon[stepsWithoutIcon.length - 1]?.component
                                        : stepsWithIcon[stepsWithIcon.length - 1]?.component)
                            )}
                            <div className="stand">
                                <div className="base"></div>
                            </div>
                        </div>
                    </div>)}


            </div>
            <div className="col-md-12 footer"><Footer /></div>
        </div >

    );
};

export default Check;
